import * as React from "react";

import { getCreditTopOffendersTableColumns } from "src/core/shared/components/tables/creditTopOffendersTableColumns";
import { PaginatedParams } from "src/library/utils/apiTypes";
import {
  CreditTopOffendersData,
  useWidgetDataApi
} from "src/core/dashboard/api/widget-data.api";
import { useWidgetContainerSize } from "src/core/dashboard/hooks";

import Table from "../table/Table";
import DataLoadError from "../DataLoadError";
import { WidgetInnerHeader } from "../WidgetInnerHeader";
import { WidgetProps } from "../utils";

export const CreditTopOffendersWidget: React.FC<WidgetProps> = ({ widgetTypeId, filters }) => {
  const [ getCreditTopOffendersResp, getCreditTopOffendersReq ] = useWidgetDataApi("GET_CREDIT_TOP_OFFENDERS");
  const wrapperRef = React.createRef<HTMLDivElement>();
  const { size } = useWidgetContainerSize(wrapperRef);

  const onFetchData = React.useCallback((params: {pagination: PaginatedParams<CreditTopOffendersData>}) => {
    getCreditTopOffendersReq({
      widgetTypeId,
      filters,
      options: { pagination: params.pagination }
    });
  }, [
    filters,
    getCreditTopOffendersReq,
    widgetTypeId
  ]);

  const data = React.useMemo(() => getCreditTopOffendersResp.data?.result?.result, [ getCreditTopOffendersResp.data?.result?.result ]);
  const columns = React.useMemo(getCreditTopOffendersTableColumns, []);

  const defaultPagination: PaginatedParams<CreditTopOffendersData> = {
    offset: 0,
    limit: 10,
    page: 0,
    sort: [ [ "requestedValue", "DESC" ] ]
  };

  return (
    <div ref={wrapperRef}>
      {getCreditTopOffendersResp.error ? (
        <DataLoadError errorMessage={getCreditTopOffendersResp.error.message} />
      ) : (
        <>
          <WidgetInnerHeader title="Credit Top Offenders" />

          <Table
            tableOf="CreditTopOffenders"
            hideHeader
            className={size}
            data={data || []}
            columns={columns}
            onFetchData={onFetchData}
            loading={getCreditTopOffendersResp.pending}
            defaultPagination={defaultPagination}
            pageCount={getCreditTopOffendersResp.data?.result?.pages}
            rowCount={getCreditTopOffendersResp.data?.result?.count}
          />
        </>
      )}
    </div>
  );
};
